var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdificioDolar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55.466,
    height: 59.428,
    viewBox: "0 0 55.466 59.428",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "edificio-dolar",
    transform: "translate(-1.5 -1.492)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31500",
    "data-name": "Trazado 31500",
    d: "M13.386,1.492H41.119v21.79a1.981,1.981,0,1,1-3.962,0V5.454H13.386A3.974,3.974,0,0,0,9.424,9.416V53h5.943v-9.9a3.974,3.974,0,0,1,3.962-3.962h7.924a3.974,3.974,0,0,1,3.962,3.962V53a1.981,1.981,0,1,1,0,3.962H1.5V53H5.462V9.416A7.922,7.922,0,0,1,13.386,1.492Zm13.867,41.6H19.328V53h7.924Z",
    transform: "translate(0 0)",
    fill: "#00c1d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31501",
    "data-name": "Trazado 31501",
    d: "M9.962,4.492H7.981A1.987,1.987,0,0,0,6,6.473v3.962H9.962Z",
    transform: "translate(7.386 4.924)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31502",
    "data-name": "Trazado 31502",
    d: "M9.962,8.242v5.943H6V8.242Z",
    transform: "translate(7.386 11.078)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31503",
    "data-name": "Trazado 31503",
    d: "M26.886,18.416a3.974,3.974,0,0,1,3.962,3.962,1.981,1.981,0,1,0,3.962,0,7.922,7.922,0,0,0-7.924-7.924V12.473a1.981,1.981,0,0,0-3.962,0v1.981a7.924,7.924,0,0,0,0,15.848v7.924a3.974,3.974,0,0,1-3.962-3.962,1.981,1.981,0,0,0-3.962,0,7.922,7.922,0,0,0,7.924,7.924v1.981a1.981,1.981,0,0,0,3.962,0V42.187a7.924,7.924,0,1,0,0-15.848Zm-7.924,3.962a3.974,3.974,0,0,1,3.962-3.962V26.34A3.974,3.974,0,0,1,18.962,22.378ZM26.886,30.3a3.962,3.962,0,0,1,0,7.924Z",
    transform: "translate(22.157 14.771)",
    fill: "#00c1d4",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31504",
    "data-name": "Trazado 31504",
    d: "M9.962,11.992H6v5.943H9.962Z",
    transform: "translate(7.386 17.233)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31505",
    "data-name": "Trazado 31505",
    d: "M9,11.992h3.962v5.943H9Z",
    transform: "translate(12.309 17.233)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31506",
    "data-name": "Trazado 31506",
    d: "M15.962,11.992H12v5.943h3.962Z",
    transform: "translate(17.233 17.233)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31507",
    "data-name": "Trazado 31507",
    d: "M12.962,8.242H9v5.943h3.962Z",
    transform: "translate(12.309 11.078)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31508",
    "data-name": "Trazado 31508",
    d: "M12,8.242h3.962v5.943H12Z",
    transform: "translate(17.233 11.078)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31509",
    "data-name": "Trazado 31509",
    d: "M9,4.492h3.962v5.943H9Z",
    transform: "translate(12.309 4.924)",
    fill: "#00c1d4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_31510",
    "data-name": "Trazado 31510",
    d: "M15.962,4.492H12v5.943h3.962Z",
    transform: "translate(17.233 4.924)",
    fill: "#00c1d4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdificioDolar);
export default __webpack_public_path__ + "static/media/edificio-dolar.4b2e0aee301886e3a81ab382faeb31d7.svg";
export { ForwardRef as ReactComponent };